import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderClinicDocuments: build.query<
      GetV2ProviderClinicDocumentsApiResponse,
      GetV2ProviderClinicDocumentsApiArg
    >({
      query: () => ({ url: `/v2/provider/clinic-documents` }),
    }),
    postV2ProviderClinicDocuments: build.mutation<
      PostV2ProviderClinicDocumentsApiResponse,
      PostV2ProviderClinicDocumentsApiArg
    >({
      query: () => ({ url: `/v2/provider/clinic-documents`, method: "POST" }),
    }),
    getV2ProviderClinicDocumentsSectionsBySectionId: build.query<
      GetV2ProviderClinicDocumentsSectionsBySectionIdApiResponse,
      GetV2ProviderClinicDocumentsSectionsBySectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/sections/${queryArg.sectionId}`,
      }),
    }),
    getV2ProviderClinicDocumentsSectionsBySectionIdContent: build.query<
      GetV2ProviderClinicDocumentsSectionsBySectionIdContentApiResponse,
      GetV2ProviderClinicDocumentsSectionsBySectionIdContentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/sections/${queryArg.sectionId}/content`,
      }),
    }),
    deleteV2ProviderClinicDocumentsByClinicDocumentId: build.mutation<
      DeleteV2ProviderClinicDocumentsByClinicDocumentIdApiResponse,
      DeleteV2ProviderClinicDocumentsByClinicDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderClinicDocumentsByClinicDocumentId: build.query<
      GetV2ProviderClinicDocumentsByClinicDocumentIdApiResponse,
      GetV2ProviderClinicDocumentsByClinicDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}`,
      }),
    }),
    getV2ProviderClinicDocumentsByClinicDocumentIdExtractionResultsAndTaskName:
      build.query<
        GetV2ProviderClinicDocumentsByClinicDocumentIdExtractionResultsAndTaskNameApiResponse,
        GetV2ProviderClinicDocumentsByClinicDocumentIdExtractionResultsAndTaskNameApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}/extraction-results/${queryArg.taskName}`,
        }),
      }),
    getV2ProviderClinicDocumentsByClinicDocumentIdFile: build.query<
      GetV2ProviderClinicDocumentsByClinicDocumentIdFileApiResponse,
      GetV2ProviderClinicDocumentsByClinicDocumentIdFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}/file`,
        params: {
          disposition: queryArg.disposition,
        },
      }),
    }),
    getV2ProviderClinicDocumentsByClinicDocumentIdSections: build.query<
      GetV2ProviderClinicDocumentsByClinicDocumentIdSectionsApiResponse,
      GetV2ProviderClinicDocumentsByClinicDocumentIdSectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}/sections`,
      }),
    }),
    getV2ProviderClinicDocumentsByClinicDocumentIdStatus: build.query<
      GetV2ProviderClinicDocumentsByClinicDocumentIdStatusApiResponse,
      GetV2ProviderClinicDocumentsByClinicDocumentIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/clinic-documents/${queryArg.clinicDocumentId}/status`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderClinicDocumentsApiResponse =
  /** status 200 OK */ ClinicDocumentListResponse;
export type GetV2ProviderClinicDocumentsApiArg = void;
export type PostV2ProviderClinicDocumentsApiResponse =
  /** status 200 OK */ ClinicDocumentUploadResponse;
export type PostV2ProviderClinicDocumentsApiArg = void;
export type GetV2ProviderClinicDocumentsSectionsBySectionIdApiResponse =
  /** status 200 OK */ SectionDetailResponse;
export type GetV2ProviderClinicDocumentsSectionsBySectionIdApiArg = {
  sectionId: string;
};
export type GetV2ProviderClinicDocumentsSectionsBySectionIdContentApiResponse =
  /** status 200 OK */ SectionContentResponse;
export type GetV2ProviderClinicDocumentsSectionsBySectionIdContentApiArg = {
  sectionId: string;
};
export type DeleteV2ProviderClinicDocumentsByClinicDocumentIdApiResponse =
  /** status 200 OK */ ClinicDocumentStatusResponse;
export type DeleteV2ProviderClinicDocumentsByClinicDocumentIdApiArg = {
  clinicDocumentId: string;
};
export type GetV2ProviderClinicDocumentsByClinicDocumentIdApiResponse =
  /** status 200 OK */ ClinicDocumentDetailResponse;
export type GetV2ProviderClinicDocumentsByClinicDocumentIdApiArg = {
  clinicDocumentId: string;
};
export type GetV2ProviderClinicDocumentsByClinicDocumentIdExtractionResultsAndTaskNameApiResponse =
  /** status 200 OK */ ExtractionResultResponse;
export type GetV2ProviderClinicDocumentsByClinicDocumentIdExtractionResultsAndTaskNameApiArg =
  {
    clinicDocumentId: string;
    taskName: string;
  };
export type GetV2ProviderClinicDocumentsByClinicDocumentIdFileApiResponse =
  unknown;
export type GetV2ProviderClinicDocumentsByClinicDocumentIdFileApiArg = {
  clinicDocumentId: string;
  /** Content-Disposition: 'inline' for viewing in browser, 'attachment' for download */
  disposition?: "inline" | "attachment";
};
export type GetV2ProviderClinicDocumentsByClinicDocumentIdSectionsApiResponse =
  /** status 200 OK */ ClinicDocumentSectionsResponse;
export type GetV2ProviderClinicDocumentsByClinicDocumentIdSectionsApiArg = {
  clinicDocumentId: string;
};
export type GetV2ProviderClinicDocumentsByClinicDocumentIdStatusApiResponse =
  /** status 200 OK */ ClinicDocumentStatusResponse;
export type GetV2ProviderClinicDocumentsByClinicDocumentIdStatusApiArg = {
  clinicDocumentId: string;
};
export type ClinicDocumentCardResponse = {
  answerable_questions?: string[];
  clinic_document_id: string;
  content_type: string;
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  filename: string;
  page_count?: number | null;
  processing_status: string;
  scope_id?: string | null;
  scope_type: string;
  size_bytes: number;
  tags?: string[];
  title?: string | null;
  toc_sections?: {
    [key: string]: any;
  }[];
  updated_at: string;
};
export type ClinicDocumentListResponse = {
  documents: ClinicDocumentCardResponse[];
  limit: number;
  offset: number;
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ClinicDocumentCardResponse2 = {
  answerable_questions?: string[];
  clinic_document_id: string;
  content_type: string;
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  filename: string;
  page_count?: number | null;
  processing_status: string;
  scope_id?: string | null;
  scope_type: string;
  size_bytes: number;
  tags?: string[];
  title?: string | null;
  toc_sections?: {
    [key: string]: any;
  }[];
  updated_at: string;
};
export type ClinicDocumentUploadResponse = {
  batch_id?: string | null;
  documents: ClinicDocumentCardResponse2[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type SectionSummaryResponse = {
  answerable_questions?: string[];
  clinic_document_section_id: string;
  depth: number;
  has_children?: boolean;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
  token_estimate?: number | null;
};
export type SectionDetailResponse = {
  children?: SectionSummaryResponse[];
  clinic_document_section_id: string;
  depth: number;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
};
export type SectionContentResponse = {
  clinic_document_section_id: string;
  content_md?: string | null;
  page_end?: number | null;
  page_start?: number | null;
  title: string;
};
export type ClinicDocumentStatusResponse = {
  clinic_document_id: string;
  processing_status: string;
  title?: string | null;
};
export type ClinicDocumentDetailResponse = {
  answerable_questions?: string[];
  batch_id?: string | null;
  clinic_document_id: string;
  content_type: string;
  created_at: string;
  description?: string | null;
  doc_kind?: string | null;
  filename: string;
  outline_md?: string | null;
  page_count?: number | null;
  processing_status: string;
  scope_id?: string | null;
  scope_type: string;
  size_bytes: number;
  supersedes_document_id?: string | null;
  tags?: string[];
  title?: string | null;
  updated_at: string;
};
export type ExtractionResultResponse = {
  clinic_document_id: string;
  created_at: string;
  error_text?: string | null;
  extracted_data?: {
    [key: string]: any;
  } | null;
  extraction_result_id: string;
  status: string;
  task_name: string;
  updated_at: string;
};
export type SectionSummaryResponse2 = {
  answerable_questions?: string[];
  clinic_document_section_id: string;
  depth: number;
  has_children?: boolean;
  node_type: string;
  retrieval_hint?: string | null;
  summary?: string | null;
  title: string;
  token_estimate?: number | null;
};
export type ClinicDocumentSectionsResponse = {
  clinic_document_id: string;
  outline_md?: string | null;
  sections: SectionSummaryResponse2[];
  title?: string | null;
};
